
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import { IPagination } from '@/types';
import {
  getStock,
  addStock,
  editorStock,
  delStock,
  addStockModel,
  editorStockModel,
  delStockModel,
  exportStockNew
} from '@/api/stock';
import DialogUpload from '../staff/components/setImport.vue';
import StockChildrenList from './components/StockChildrenList.vue';
import { Qiniu } from '@/types/qiniu';
import { getQiniuToken } from '@/api/third';
import { makeKey } from '@/utils/qiniu';
import dialogImgLarge from '@/components/ImgLarge/index.vue';
import { checkPermissionCompany } from '@/utils/permission';
import { Type } from '@/types/permissionType';
import { toFixed2 } from '@/utils';

@Component({
  name: 'StockIndex',
  components: {
    DialogUpload,
    StockChildrenList,
    dialogImgLarge
  }
})
export default class extends Vue {
  private formSearch = {
    name: '',
    model: '',
    serial: '',
    specification: '',
    type: ''
  }
  private typeOptions = [
    {
      value: '1',
      label: '备件导入'
    },
    {
      value: '2',
      label: '手动添加'
    }
  ]
  private pagination: IPagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  }
  private tableData = []
  private setUploadVisible = false
  private setUploadTitle = '上传库存'

  private dialogEditStockName = false
  private formEditStockName = {
    id: '',
    stockName: ''
  }

  private dialogAddModel = false;
  private verifyShow=true;
  private formAddModel = {
    isEdit: true,
    id: '',
    model_id: '',
    name: '',
    model_name: '',
    serial_number: '',
    specification: '',
    unit_price:'',
    remark: '',
    image_save_path: '',
    imageUrl: ''
  }

  // 操作子级名称后刷新对应层级的回调（为空时刷新主列表）
  private pendingRefresh: (() => void) | null = null;

  private rules = {
    model_name: [{ required: true, message: '请填写型号', trigger: 'blur' }],
    stockName: [
      { required: true, message: '请填填写名称', trigger: 'blur' },
      {
        min: 2,
        max: 20,
        message: '请输入2-20位由数字、字母、中文组成的名称',
        trigger: 'blur'
      },
      {
        pattern: /^[A-Za-z0-9\u4e00-\u9fa5]{2,20}$/,
        message: '请输入2-20位由数字、字母、中文组成的名称',
        trigger: 'blur'
      }
    ]
  }

  created() {
    this.verifyShow = !checkPermissionCompany(UserModule.getCompanyId, Type.PersonStock);
    this.getStock();
    this.getqiniu();
  }

  // 上传库存
  private uploadHandle() {
    this.setUploadVisible = true;
  }
  private closeUpload(val: any) {
    this.getStock();
    this.setUploadVisible = val;
  }

  // 导出库存(含二级库存)
  private exportHandle() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.name = this.formSearch.name;
    params.type = this.formSearch.type;
    exportStockNew(params)
      .then((res) => {
        this.$confirm('是否跳转下载页面？', '跳转', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let routeData = this.$router.resolve({
            path: '/ExportTask',
            query: {}
          });
          window.open(routeData.href);
        }).catch(() => {

        });
      })
      .catch((error) => {
        this.tableData = [];
        let msg = error.msg;
      });
  }

  // 库存核销
  private verifyHandle() {
    this.$router.push({
      path: 'verification'
    });
  }

  // 收起所有一级展开行（row-key 模式下数据刷新后展开状态会按 id 保留，需手动收起）
  private collapseAllRows() {
    const table: any = this.$refs.stockTable;
    if (!table) {
      return;
    }
    const expandRows: any[] = (table.store.states.expandRows || []).slice();
    expandRows.forEach((row: any) => {
      table.toggleRowExpansion(row, false);
    });
  }

  private search() {
    this.pagination.currentPage = 1;
    this.collapseAllRows();
    this.getStock();
  }

  private searchClean() {
    this.formSearch = {
      name: '',
      model: '',
      serial: '',
      specification: '',
      type: ''
    };
    this.pagination.currentPage = 1;
    this.collapseAllRows();
    this.getStock();
  }

  // 获取一级（大类）列表
  private getStock() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.name = this.formSearch.name;
    params.model_name = this.formSearch.model;
    params.serial_number = this.formSearch.serial;
    params.specification = this.formSearch.specification;
    params.type = this.formSearch.type;
    params.pid = 0;
    params.page = this.pagination.currentPage;
    params.size = this.pagination.pageSize;
    getStock(params)
      .then((res) => {
        if (res.data) {
          this.pagination.total = parseInt(res.data.count);
          this.tableData = res.data.list;
        } else {
          this.pagination.currentPage = 1;
          this.pagination.total = 0;
          this.tableData = [];
        }
      })
      .catch((error) => {
        this.tableData = [];
        let msg = error.msg;
      });
  }

  // 展开行：懒加载下级名称（库存列表接口传 pid 获取）
  private handleExpandChange(row: any, expandedRows: any[]) {
    const expanded = expandedRows.some((item: any) => item.id === row.id);
    if (expanded) {
      this.fetchChildren(row);
    }
  }

  private fetchChildren(row: any) {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      pid: row.id,
      page: 1,
      size: 9999
    };
    getStock(params)
      .then((res: any) => {
        const data = res.data;
        const list = data && data.list ? data.list : [];
        this.$set(row, 'childrenx', list);
      })
      .catch((err: any) => {
        let msg = err.msg;
      });
  }

  // 增删改后刷新：优先刷新子级名称所在层级，否则刷新主列表
  private refreshAfter() {
    const refresh = this.pendingRefresh;
    this.pendingRefresh = null;
    if (refresh) {
      refresh();
    } else {
      this.getStock();
    }
  }

  private priceCount(row:any){
    //20230720存在无库存的没有返回num
    if(row.num!=undefined && row.unit_price!=undefined){
      return  (parseFloat(row.unit_price) * parseFloat(row.num)).toFixed(2)
    }else{
      return '';
    }
  }

  // 页面属性更新
  private handlePageSizeChange(val: any) {
    this.pagination.pageSize = val;
    this.getStock();
  }
  private handleCurrentChange(val: any) {
    this.pagination.currentPage = val;
    this.getStock();
  }

  // 添加一级（大类）
  private addStock() {
    this.pendingRefresh = null;
    this.$prompt('名称', '添加大类', {
      inputPlaceholder: '请输入大类名称',
      inputErrorMessage: '请输入2-20位由数字、字母、中文组成的名称',
      inputPattern: /^[A-Za-z0-9\u4e00-\u9fa5]{2,20}$/
    })
      .then(({ value }: any) => {
        if (value == null) {
          this.$message({
            type: 'info',
            message: '请输入大类名称'
          });
          return false;
        }
        let params: any = {};
        params.user_id = UserModule.getUserId;
        params.company_id = UserModule.getCompanyId;
        params.name = value;
        addStock(params)
          .then((res) => {
            this.refreshAfter();
            this.showSuccessMsg('添加成功');
          })
          .catch((error) => {
            let msg = error.msg;
            this.showErrorMsg(msg);
          });
      })
      .catch(() => {
        this.pendingRefresh = null;
      });
  }

  // 添加下级名称按钮触发
  private addChildNameHandle(val: any, refresh?: () => void) {
    this.pendingRefresh = refresh || null;
    this.$prompt('名称', '添加名称', {
      inputPlaceholder: `请输入名称（上级：${val.name}）`,
      inputErrorMessage: '请输入2-20位由数字、字母、中文组成的名称',
      inputPattern: /^[A-Za-z0-9\u4e00-\u9fa5]{2,20}$/
    })
      .then(({ value }: any) => {
        let params: any = {};
        params.user_id = UserModule.getUserId;
        params.company_id = UserModule.getCompanyId;
        params.name = value;
        params.pid = val.id;
        addStock(params)
          .then((res) => {
            this.refreshAfter();
            this.showSuccessMsg('添加成功');
          })
          .catch((error) => {
            let msg = error.msg;
            this.showErrorMsg(msg);
          });
      })
      .catch(() => {
        this.pendingRefresh = null;
      });
  }

  // 删除库存
  private deleteStockHandle(val: any, refresh?: () => void) {
    this.pendingRefresh = refresh || null;
    this.$confirm('确认删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        this.deleteStockDo(val);
      })
      .catch(() => {
        this.pendingRefresh = null;
      });
  }

  private deleteStockDo(val: any) {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      id: val.id
    };
    delStock(params)
      .then((res) => {
        this.showSuccessMsg('删除成功');
        this.refreshAfter();
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }

  // 编辑库存名称
  private editStock(val: any, refresh?: () => void) {
    this.pendingRefresh = refresh || null;
    this.dialogEditStockName = true;
    this.formEditStockName = {
      id: val.id,
      stockName: val.name
    };
  }

  // 关闭编辑库存名称dialog
  private beforedialogEditStockNameClose() {
    this.dialogEditStockName = false;
    this.pendingRefresh = null;
  }

  // 确认编辑库存名称
  private confirmEditStockName() {
    (this.$refs.ruleForm as any).validate((valid: any) => {
      if (valid) {
        let params: any = {};
        params.user_id = UserModule.getUserId;
        params.company_id = UserModule.getCompanyId;
        params.name = this.formEditStockName.stockName;
        params.id = this.formEditStockName.id;
        editorStock(params)
          .then((res) => {
            this.dialogEditStockName = false;
            this.refreshAfter();
            this.showSuccessMsg('编辑成功');
          })
          .catch((error) => {
            let msg = error.msg;
            this.showErrorMsg(msg);
          });
      } else {
        return false;
      }
    });
  }

  // 添加型号
  private addStockModel(val: any, refresh?: () => void) {
    this.pendingRefresh = refresh || null;
    this.dialogAddModel = true;
    this.formAddModel = {
      isEdit: false,
      id: val.id,
      name: val.name,
      model_id: '',
      model_name: '',
      serial_number: '',
      specification: '',
      unit_price:'',
      remark: '',
      image_save_path: '',
      imageUrl: ''
    };
  }

  // 编辑型号
  private editStockModel(val: any, refresh?: () => void) {
    this.pendingRefresh = refresh || null;
    this.dialogAddModel = true;
    this.formAddModel = {
      isEdit: true,
      id: val.stock_id,
      model_id: val.id,
      name: val.name,
      model_name: val.model.model_name,
      serial_number: val.serial_number,
      specification: val.specification,
      unit_price: val.unit_price,
      remark: val.remark,
      image_save_path: val.image_save_path,
      imageUrl: ''
    };
  }
  // 关闭 添加编辑型号dialog
  private beforeAddModelClose() {
    this.dialogAddModel = false;
    this.pendingRefresh = null;
  }

  // 确认添加编辑型号
  private confirmModel() {
    (this.$refs.ruleFormModel as any).validate((valid: any) => {
      if (valid) {
        if (this.formAddModel.isEdit) {
          this.editModel();
        } else {
          this.addModel();
        }
      } else {
        return false;
      }
    });
  }
  private addModel() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.id = this.formAddModel.id;
    params.model_name = this.formAddModel.model_name;
    params.serial_number = this.formAddModel.serial_number;
    params.specification = this.formAddModel.specification;
    params.unit_price = this.formAddModel.unit_price;
    params.remark = this.formAddModel.remark;
    params.src_path = this.formAddModel.image_save_path;
    addStockModel(params)
      .then((res) => {
        this.dialogAddModel = false;
        this.refreshAfter();
        this.showSuccessMsg('添加成功');
      })
      .catch((error) => {
        let msg = error.msg;
      });
  }
  private editModel() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.id = this.formAddModel.id;
    params.model_id = this.formAddModel.model_id;
    params.model_name = this.formAddModel.model_name;
    params.serial_number = this.formAddModel.serial_number;
    params.specification = this.formAddModel.specification;
    params.unit_price = this.formAddModel.unit_price;
    params.remark = this.formAddModel.remark;
    params.src_path = this.formAddModel.image_save_path;
    editorStockModel(params)
      .then((res) => {
        this.dialogAddModel = false;
        this.refreshAfter();
        this.showSuccessMsg('编辑成功');
      })
      .catch((error) => {
        let msg = error.msg;
      });
  }
  // 删除型号
  private deleteStockModelHandle(val: any, refresh?: () => void) {
    this.pendingRefresh = refresh || null;
    this.$confirm('确认删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        this.deleteStockModelDo(val);
      })
      .catch(() => {
        this.pendingRefresh = null;
      });
  }

  private deleteStockModelDo(val: any) {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      model_id: val.id
    };
    delStockModel(params)
      .then((res) => {
        this.showSuccessMsg('删除成功');
        this.refreshAfter();
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }
  /**
   * 校验售价格式
   */
  private formatFilter() {
      this.formAddModel.unit_price = toFixed2(this.formAddModel.unit_price);
  }
  private jumpToStockIn(val:any, val2:any) {
    this.$router.push({
      path: 'inStock',
      query: { 'stock_name': val2.name, 'model': JSON.stringify(val) }
    });
  }
  private jumpToStockOut(val:any, val2:any) {
    this.$router.push({
      path: 'outStock',
      query: { 'model_id': val.id, 'stock_name': val2.name,'model': JSON.stringify(val) }
    });
  }

  private imgLargeHandle(val: any) {
    let enlargedData = {
      isShow: true,
      imgList: [val],
      initNum: 1
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }

  // 上传图片
  private qiniu: any
  private action = 'https://up-z1.qiniup.com'
  private form: object = {}

  private getqiniu() {
    const params = {
      type: Qiniu.UPLOAD_TYPE_USER
    };
    getQiniuToken(params).then((res) => {
      if (res && res.data) {
        this.qiniu = res.data;
      }
    });
  }

  handleAvatarSuccess(res: any, file: any) {
    const imgUrl = this.qiniu.default_url + res.key;
    this.formAddModel.imageUrl = imgUrl;
    this.formAddModel.image_save_path = res.key;
  }

  beforeAvatarUpload(file: any) {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isJPG) {
      return this.$message.error('上传文件只能是  JPG或PNG 格式!');
    }
    if (!isLt2M) {
      return this.$message.error('上传图片大小不能超过 5MB!');
    }
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then((res) => {
      let k = makeKey(this.qiniu.prekey);
      this.form = {
        key: k,
        token: this.qiniu.uptoken,
        domain: this.qiniu.domain
      };
    });
  }

  private deleteImgHandle() {
    this.formAddModel.imageUrl = '';
    this.formAddModel.image_save_path = '';
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }

  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
